import type { AppContext } from "src/shared/context/AppContext";
import { isProd } from "../envUtils";
import { isClient } from "../ssrUtils";

export const isSentryEnabledByEnv = (env: AppContext["env"]) => env["REACT_APP_SENTRY_ENABLED"] === "true";

// Defaulted via isClient(), not read unconditionally — this default expression itself runs
// during SSR (where window is not defined) whenever a caller omits the argument.
export const isSupportedSentryHost = (hostname: string = isClient() ? window.location.hostname : "") =>
  !hostname.startsWith("local.") && /stubhub|viagogo/.test(hostname);

// No isClient() guard here — isSupportedSentryHost's own default already degrades safely
// during SSR when hostname is omitted, and an explicit hostname should be honored either way.
export const isSentrySupportedEnv = (env: AppContext["env"], hostname?: string) =>
  isSentryEnabledByEnv(env) && isSupportedSentryHost(hostname);

export const getSentryReleaseName = (appContext: AppContext) => {
  const envPrefix = isProd(appContext.env) ? "prod" : "dev";
  // TODO: ideally buildId and appVersion will be the same value in the future... but this is a POC
  return `${envPrefix}-discovery-${appContext.env["REACT_APP_JS_BUILD_ID"] ?? appContext.appVersion}`;
};
